<template>
  <CHeaderNavItem class="px-0">
    <CHeaderNavLink  to="/notifications">
      <CIcon name="cil-bell" />
      <CBadge
        shape="pill"
        color="primary"
        v-if="$store.state.notifications.length > 0"
        >{{ $store.state.notifications.length }}</CBadge
      >
    </CHeaderNavLink>
  </CHeaderNavItem>
  <!--  <CDropdown
    :caret="false"
    placement="bottom-end"
    in-nav
    class="c-header-nav-item mx-2 d-md-down-none"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink to="notifications">
        <CIcon name="cil-bell" />
        <CBadge
          shape="pill"
          color="primary"
          v-if="$store.state.notifications.length>0"
        >{{$store.state.notifications.length}}</CBadge>
      </CHeaderNavLink>
    </template> -->
  <!--     <CDropdownHeader
      tag="div"
      class="text-center bg-light"
      v-if="$store.state.notifications.length>0"
    >
      <strong>You have {{$store.state.notifications.length}} new notifications</strong>
    </CDropdownHeader>

    <CDropdownItem href="#" v-for="(notification,index) in notificationsLimit" :key="index">
      <div class="message">
        <div>
          <small class="text-muted">{{notification.from}}ObjectPower</small>
          <small class="text-muted float-right mt-1">{{notification.created_at | formatTimeago}}</small>
        </div>
        <div class="pt-2">
          <div class="badgecontainer inline mr-5">
            <i class="fa fa-bell text-primary"></i>
            <CBadge
              class="notificationtype"
              shape="pill"
              :color="notificationBadgeColor(notification)"
            >{{notificationBadgeText(notification)}}</CBadge>
          </div>
          <div class="text-truncate small font-weight-bold">{{notification.name}}</div>
        </div>
            </div>
    </CDropdownItem> -->

  <!--  <CDropdownItem to="notifications" class="border-top text-center">
      <strong>View all notifications</strong>
    </CDropdownItem> -->
  <!--   </CDropdown> -->
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "TheHeaderDropdownNotif",
  data() {
    return {
      notificationLimit: 10,
    };
  },
  computed: {
    ...mapGetters(["notifications", "user"]),
    notificationsLimit() {
      return this.notificationLimit
        ? this.notifications.slice(0, this.notificationLimit)
        : this.notifications;
    },
  },
  methods: {
    notificationBadgeColor(notification) {
      switch (notification.type) {
        case 0:
          return "success";
          break;
        case 1:
          return "secondary";
          break;
      }
      return;
    },
    notificationBadgeText(notification) {
      switch (notification.type) {
        case 0:
          return "Message";
          break;
        case 1:
          return "Receipt";
          break;
      }
      return;
    },
  },
};
</script>
